import { atom } from "recoil";
import { ISafeType } from "../types";

export const addStateSafeType = atom({
  key: "addStateSafeType",
  default: false,
});
export const editStateSafeType = atom({
  key: "editStateSafeType",
  default: false,
});
export const rowEditSafeType = atom<ISafeType | undefined>({
  key: "rowEditSafeType",
  default: undefined,
});

export const selectedRowsStateSafeType = atom<ISafeType[]>({
  key: "selectedRowsStateSafeType",
  default: [],
});

export const safeTypeFilterText = atom({
  key: "safeTypeFilterText",
  default: "",
});

export const safeTypeFetching = atom({
  key: "safeTypeFetching",
  default: true,
});
export const safeTypeReFetching = atom({
  key: "safeTypeReFetching",
  default: false,
});
